import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Card, Table, Button, ButtonGroup, DropdownButton, Dropdown, Spinner, Modal } from 'react-bootstrap';
import { format } from 'date-fns';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import Avatar from "../../common/Avatar";
import ActionButton from "../../common/ActionButton";
import {
    list,
    items,
    remove,
    getAllPlayers,
    listPlayers,
    listItem,
    removeItem
} from "../../../lib/api/registration";
import { Add } from './AddItem';
import { toast } from 'react-toastify';


export const Items = ({ initRegistration, initMode, onClose, onSave }) => {
  console.log('.....................................');
  console.log('initRegistration',initRegistration)
  const registration_guid = initRegistration.registration_guid;
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [registration, setRegistration] = useState(initRegistration);
  const [mode, setMode] = useState(initMode);
  const [players, setPlayers] = useState([]);
  const [rows, setRows] = useState([]);

   const getPlayers = () => {
       listItem(registration_guid)
        .then((res) => {
          console.log('PPPP',res)
          setPlayers(res)
        })
        .catch((err) => console.error(err))
  };

    const getAllPlayers = () => {
        listPlayers(registration_guid)
            .then((res) => {
                const _rows = res.map(p => ({
                    ...p,
                    value: p.player_id,
                    label: `${p.player_id} - ${p.name} ${p.last_name} (${formatDateTime(p.date_of_birth)})`.trim()+(p.club_name ? ' ('+p.club_name+')' : '')
                }));
                console.log('setRows', _rows)
                console.log('setRows', _rows)
                setRows(_rows)
            })
            .catch((err) => console.error(err))
    };

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);

        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const yyyy = date.getFullYear();

        return `${dd}.${mm}.${yyyy}`;
    }

  useEffect(() => {
    (async () => {
      console.log('ID iz URL-a:', registration_guid);
      setIsLoading(true);
      await getData();
      setIsLoading(false);
    })();
  }, [registration_guid]);

    const getData = async () => {
        await getPlayers();
        await getAllPlayers();
    };


  const handleNew = () => {
      setShowModal(true);
  };

  const handelDelete = async (id) => {
      console.log('players', players);
      const item = players.find(c => c.registration_players_guid === id);
      console.log('item',item)
      await removeItem(item.registration_players_guid);
      await getData();
      setPlayers((prev) => prev.filter((p) => p.registration_players_guid !== id));
  };

  const renderDeleteAction = item =>
    mode === 'edit' ? (
      <ActionButton
        onClick={() => handelDelete(item.registration_players_guid)}
        icon="trash-alt"
        title="Delete"
        variant="action"
        className="p-0"
      />
    ) : null;

  return (
    <Card className={classNames('h-100')}>
      <Card.Header>
        <Row className={classNames('g-2')}>
          <Col>
            <Flex>
              <h5 className="mb-0 hover-actions-trigger text-truncate text-nowrap">
                Pristupnica - Prva registracija
              </h5>
            </Flex>
          </Col>
          <Col xs="auto">
            {mode === 'edit' && (
              <Button onClick={handleNew} variant="primary">
                +
              </Button>
            )}
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="bg-body-tertiary">
        {isLoading ? (
          <div className="text-center">
            <Spinner animation="border" role="status" />
          </div>
        ) : (
          <Row className="mb-3">
            <div className="d-none d-xl-block">
              <Table responsive>
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Datum rođenja</th>
                    <th scope="col">Mjesto</th>
                    <th scope="col">Licenca</th>
                    {mode === 'edit' && (
                      <th className="text-end" scope="col">
                        Actions
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {players.map((item, i) => (
                    <tr key={i}>
                      <td className="text-nowrap">
                        <div className="d-flex align-items-center">
                          <div className="ms-2">{players.length - i}</div>
                        </div>
                      </td>
                      <td>
                        <div className="ms-2">
                          {item.name} {item.last_name}
                        </div>
                      </td>
                      <td>
                        <div className="ms-2">
                          {format(item.date_of_birth, 'dd.MM.yyyy')}
                        </div>
                      </td>
                      <td>
                        <div className="ms-2">{item.place}</div>
                      </td>
                      <td>
                        <div className="ms-2">{item.player_id}</div>
                      </td>
                      {mode === 'edit' && (
                        <td className="text-end">{renderDeleteAction(item)}</td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="d-xl-none">
              <Row className="g-3">
                {players.map((item, i) => (
                  <Col xs={12} key={item.registration_players_guid || i}>
                    <div
                      className="border rounded-4 bg-white h-100 p-3 shadow-sm"
                      style={{ borderColor: '#dfe3ee' }}
                    >
                      <div className="d-flex align-items-start justify-content-between gap-3">
                        <div className="flex-shrink-0">
                          <div className="text-700 fs-10 fw-semibold">#{players.length - i}</div>
                        </div>
                        {mode === 'edit' && (
                          <div className="flex-shrink-0">{renderDeleteAction(item)}</div>
                        )}
                      </div>

                      <div className="mt-3">
                        <div className="fw-semibold text-dark fs-8">
                          {item.name} {item.last_name}
                        </div>

                        <div className="d-flex flex-wrap gap-2 mt-2">
                          <span className="badge rounded-pill badge-subtle-success">
                            {item.player_id || '-'}
                          </span>
                        </div>

                        <div className="text-600 fs-10 mt-2">
                          {format(item.date_of_birth, 'dd.MM.yyyy')}
                        </div>

                        <div className="text-700 fs-10 mt-1">{item.place || '-'}</div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Row>
        )}
      </Card.Body>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Dodaj igrača</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Add
            initRegistration={registration}
            initRows={rows}
            onClose={() => setShowModal(false)}
            onSave={getData}
          />
        </Modal.Body>
      </Modal>
    </Card>
  );
};

export default Items;
